import { useState } from "react";
import { Check, Loader2, ShieldCheck, ShieldOff, HelpCircle } from "lucide-react";

const LABEL = { true: ["Consenso attivo", "text-emerald-700 bg-emerald-50 border-emerald-200", ShieldCheck], false: ["Nessun consenso", "text-rose-700 bg-rose-50 border-rose-200", ShieldOff], unknown: ["Non documentato", "text-amber-700 bg-amber-50 border-amber-200", HelpCircle] };
const NAME = { whatsapp: "WhatsApp", sms: "SMS" };

export function PortalConsentCard({ channel, data, privacy, busy, onChange }) {
  const [open, setOpen] = useState(false);
  const [read, setRead] = useState(false);
  const [label, cls, Icon] = LABEL[String(data.value)];
  const declaration = privacy.declaration[channel].replace("{version}", privacy.version);
  const grant = () => onChange(channel, true, { confirm: true, privacy_version: privacy.version, declaration }).then(() => { setOpen(false); setRead(false); });
  return (
    <section className="rounded-2xl border border-stone-200 bg-white p-5 shadow-sm space-y-4" data-testid={`portal-channel-${channel}`}>
      <div className="flex items-start justify-between gap-3">
        <div>
          <h2 className="text-lg font-semibold text-stone-900">{NAME[channel]}</h2>
          <p className="text-xs text-stone-500">Comunicazioni di marketing su questo canale</p>
        </div>
        <span className={`inline-flex items-center gap-1 rounded-full border px-3 py-1 text-xs font-semibold ${cls}`} data-testid={`portal-${channel}-value`}><Icon className="w-3.5 h-3.5" />{label}</span>
      </div>
      <p className="text-sm text-stone-600" data-testid={`portal-${channel}-preview`}>
        Marketing: <b>{data.preview.marketing.allowed ? "lo riceverai" : "non lo riceverai"}</b> · Messaggi di servizio e codici richiesti da te: <b>{data.preview.service.allowed ? "sì" : "no"}</b>
      </p>
      {data.reactivation_blocked && (
        <p className="rounded-lg bg-stone-100 p-3 text-sm text-stone-700" data-testid={`portal-${channel}-blocked`}>
          Hai precedentemente richiesto di non ricevere comunicazioni su questo canale. Per registrare una nuova adesione, contatta il mittente.
        </p>)}
      <div className="flex flex-wrap gap-2">
        {data.can_revoke && (
          <button disabled={busy} onClick={() => onChange(channel, false, {})} data-testid={`portal-${channel}-revoke-btn`}
            className="rounded-full border border-rose-300 px-4 py-2 text-sm font-medium text-rose-700 transition-colors hover:bg-rose-50 disabled:opacity-50">
            Non voglio più ricevere marketing via {NAME[channel]}
          </button>)}
        {data.can_grant && !open && (
          <button disabled={busy} onClick={() => setOpen(true)} data-testid={`portal-${channel}-grant-btn`}
            className="rounded-full bg-stone-900 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-stone-700 disabled:opacity-50">
            Voglio ricevere marketing via {NAME[channel]}
          </button>)}
      </div>
      {open && (
        <div className="rounded-xl border border-stone-200 bg-stone-50 p-4 space-y-3" data-testid={`portal-${channel}-grant-form`}>
          <p className="text-sm font-semibold text-stone-900">{privacy.title} <span className="text-xs font-normal text-stone-500">(versione {privacy.version})</span></p>
          <p className="text-sm text-stone-700 leading-relaxed">{privacy.text}</p>
          <label className="flex items-start gap-3 text-sm text-stone-800 cursor-pointer">
            <input type="checkbox" checked={read} onChange={(e) => setRead(e.target.checked)} className="mt-1 h-4 w-4 accent-stone-900" data-testid={`portal-${channel}-declaration-checkbox`} />
            <span>{declaration}</span>
          </label>
          <div className="flex gap-2 justify-end">
            <button onClick={() => { setOpen(false); setRead(false); }} className="rounded-full px-4 py-2 text-sm text-stone-600 hover:bg-stone-200" data-testid={`portal-${channel}-grant-cancel`}>Annulla</button>
            <button disabled={!read || busy} onClick={grant} data-testid={`portal-${channel}-grant-confirm`}
              className="inline-flex items-center gap-2 rounded-full bg-emerald-700 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-emerald-600 disabled:opacity-40">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />} Confermo il consenso
            </button>
          </div>
        </div>)}
    </section>);
}
